import type Scene from "../models/Scene";
import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";
import BaseModelReference from "../models/BaseModelReference";
import Logger from "../Logger";
import BaseModel from "../models/BaseModel";
import Connection from "../models/Connection";
import type ConnectableObject from "../models/ConnectableObject";
import { sortArrayByIntProperty, sortArrayByProperty } from "../models/utils";
import { isUiModeExpert } from "../uiMode";
import Multiplexer from "../models/Multiplexer";
import GroupAddress from "../models/GroupAdress";
import AllowedConnections from "../models/AllowedConnections";
import { itx } from "../translationItx/itx";
import ObjectReference from "../components/ObjectReference";
import Consumer from "../models/Consumer";
import Channel from "../models/Channel";
import { getChannelTypePicture } from "../models/ChannelType";
import ButtonChannel from "../models/ButtonChannel";

const logger = new Logger();

export default class SceneTreeViewModel extends TreeViewModel {
  get typedObj(): Scene {
    return this.obj as Scene;
  }

  getTitlePostfix(): string | JSX.Element {
    if (this.typedObj.className == "Multiplexer") {
      return "";
    } else {
      return `(${this.typedObj.sceneNumber})`;
    }
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return this.typedObj.className == "Multiplexer";
  }

  getDisableEdit(): boolean {
    return false;
  }

  get childCollection(): Array<BaseModel> | undefined {
    let children = new Array<BaseModel>();

    let partners = new Array<BaseModel>();

    this.typedObj.connections.forEach((connection) => {
      const scene = this.typedObj;
      if (scene) {
        const partner = connection.getPartner(scene!!);
        if (partner) {
          partners.push(partner);
        }
      }
    });

    partners = sortArrayByProperty(partners, "fullTag");

    partners.forEach((partner) => {
      const ref = new BaseModelReference({ referencedObject: partner }, this.typedObj);
      ref.usefromRefencedTreeviewObject = {
        titlePostfix: true,
        fullTitle: false,
        icon: true,
      };

      let channel: Channel | undefined;
      if (partner.isConsumer) {
        channel = (partner as Consumer).getConnectedChannel();
      }

      ref.overwriteFulltag = "";
      ref.overwriteIcon = " ";
      ref.overwritePostfix = "";
      ref.overwritePrefix = " ";
      ref.overwriteIcon = " ";

      ref.overwriteFullTitle = (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <ObjectReference
            className="nav_C3"
            obj={partner}
            showName
            showIcon={
              <img
                style={{ height: "20px", marginRight: "10px" }}
                src={getChannelTypePicture(partner as ButtonChannel)}
              />
            }
            style={{ height: "30px" }}
          />

          {isUiModeExpert() && channel && (
            <ObjectReference className="nav_C4" obj={channel} showName style={{ height: "30px" }} />
          )}
        </div>
      );

      if (partner) {
        children.push(ref);
      }
    });

    if (this.typedObj.className == "Multiplexer" && isUiModeExpert()) {
      const multiplexer = this.typedObj as Multiplexer;
      const gas = new Array<GroupAddress>();
      multiplexer.signals.forEach((signal) => {
        if (signal.groupAddresses.items[0]) {
          gas.push(signal.groupAddresses.items[0]);
        }
      });

      children = children.concat(sortArrayByIntProperty(gas, "number"));
    }

    return children;
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      items: [
        this.baseContextMenuItems_Copy(),
        this.baseContextMenuItems_Paste(subLabelPaste),
        this.baseContextMenuItems_Delete(),
        // this.baseContextMenuItems_Open(),
      ],
    };
  }

  allowDrag(): boolean {
    return true;
  }

  allowDrop(event: any): boolean {
    return true;
  }
  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    if (obj.className == "Consumer" || obj.className == "ButtonChannel") {
      if (this.typedObj.className == "Multiplexer") {
        if (!AllowedConnections.isConnectionAllowed(obj as ConnectableObject, this.typedObj, false)) {
          return new DropResult(false, itx("sceneTreeviewModel.connectionForbidden", "Verbindung ist nicht erlaubt"));
        }
      }
      const res = Connection.createConnection(obj as ConnectableObject, this.typedObj);

      if (res.connection) {
        if (!AllowedConnections.isConnectionAllowed(obj as ConnectableObject, this.typedObj, false)) {
          res.connection.forbidden = true;
        }
        obj.raiseOnChange("childCollection");
        this.typedObj.raiseOnChange("childCollection");
        return new DropResult(true, res.msg);
      }

      //return new DropResult(false, "Verbindung ist nicht erlaubt");
    }
    return new DropResult(false);
  }
  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Open("ContextMenuLables.open")]; // no itx
  }
}
